import GroupUrlSubmit from './GroupUrlSubmit';
import ReviewLinks from './ReviewLinks';
import ReviewWholescale from './ReviewWholescale';
import ReviewYotpo from './ReviewYotpo';
import TextSubmit from './TextSubmit';
import TiktokPublish from './TiktokPublish';
import UrlSubmit from './UrlSubmit';

const index = {
  GroupUrlSubmit,
  ReviewLinks,
  ReviewWholescale,
  ReviewYotpo,
  TextSubmit,
  TiktokPublish,
  UrlSubmit,
};

export default index;